export default {
  "checkOrder.checkPopupBox": "检查弹出框",
  "checkOrder.checkOrderUploads": "传单检查",
  "checkOrder.checkExpired":
    "以下订单检查结果已失效，请点击【发起检查】进行检查后再传单",
  "checkOrder.CheckItems": "检查项",
  "checkOrder.checkResultLevel": "检查结果等级",
  "checkOrder.lauchInspection": "发起检查",
  "checkOrder.exportResults": "导出结果",
  "checkOrder.open": "是",
  "checkOrder.close": "否",
  "checkOrder.uploadOrder": "去传单",
  "checkOrder.checkResultDetails": "检查结果明细",
  "checkOrder.checkResult": "检查结果",
  "checkOrder.pass": "通过",
  "checkOrder.abnormal": "错误",
  "checkOrder.warn": "风险",
  "checkOrder.hint": "优化",
  "checkOrder.form": "表单",
  "checkOrder.product": "产品",
  "checkOrder.orderNumber": "订单号",
  "checkOrder.mainContractNumber": "主合同号",
  "checkOrder.brandCategory": "所属品牌品类",
  "checkOrder.productChannels": "产品渠道",
  "checkOrder.standardProducts": "标准品",
  "checkOrder.placeOrders": "下单",
  "checkOrder.placeOrders2": "去下单",
  "checkOrder.specification": "规格",
  "checkOrder.code": "编码",
  "checkOrder.model": "型号",
  "checkOrder.classification": "分类",
  "checkOrder.details": "详情",
  "checkOrder.fold": "收起",
  "checkOrder.unfold": "展开",
  "checkOrder.foldUnfold": "展开/收起",
  "checkOrder.orderParameters": "下单参数",
  "checkOrder.instruction": "说明",
  "checkOrder.beingChecked": "检查任务已发起,正在检查，请稍后...",
  "checkOrder.confirm": "确定",
  "checkOrder.closeModify": "关闭下单去修改",
  "checkOrder.checkCompleted": "检查完成",
  "checkOrder.checkFailed": "检查失败",
  "checkOrder.checkTotal": "共检查X个设计对象，包括X个错误，X个风险，X个优化",
  "checkOrder.checkTotal1": "共检查",
  "checkOrder.checkTotal2": "个设计对象，",
  "checkOrder.checkTotal3": "包括",
  "checkOrder.checkTotal4": "个错误",
  "checkOrder.checkTotal5": "个风险",
  "checkOrder.checkTotal6": "个优化",
  "checkOrder.craftsmanship":
    "以上工艺问题，请认真查阅核对，出现质量等问题将作为售服依据，由设计自行承担.",
  "checkOrder.checkPage": "一键下单页面检查结果",
  "checkOrder.checkInformation": "检查信息",
  "checkOrder.abnormalOrders": "错误订单",
  "checkOrder.warningOrder": "风险订单",
  "checkOrder.hintingOrder": "优化订单",
  "checkOrder.all": "全部",
  "checkOrder.source": "来源",
  "checkOrder.details": "详情说明",
  "checkOrder.checkDetails": "检查详情",
  "checkOrder.xItems1": "...等 ",
  "checkOrder.xItems2": " 项",
  "checkOrder.failureInformation": "查看失败信息",
  "checkOrder.detectedCheck":
    "系统检测到您当前选择的订单需要进行统一检查后才可进行传单，请点击下方的“发起检查”按钮，检查并通过后，再次传单",
  "checkOrder.inspectionItems": "选择检查项",
  "checkOrder.noInspectionItems": "暂无检查项",
  "checkOrder.viewInspectionRecords": "查看检查记录",
  "checkOrder.readingScene": "正在读取方案内容",

  "checkOrder.checking": "正在检查",
  "checkOrder.underInspection": "检查中",
  "checkOrder.inspectionRecords": "请等待检查结果，可手动刷新， 查看检查记录",
  "checkOrder.inspectionRecords1": "请等待检查结果，可手动",
  "checkOrder.inspectionRecords2": "刷新",
  "checkOrder.inspectionRecords3": "， 查看检查记录",
  "checkOrder.clickRetry": "点击重试，可再次发起检查",
  "checkOrder.clickRetry1": "点击",
  "checkOrder.clickRetry2": "重试，",
  "checkOrder.clickRetry3": "可再次发起检查",
  "checkOrder.batchID": "检查批次ID",
  "checkOrder.filledForms": "需要填写表单个数：",
  "checkOrder.clickLocate": "点击可定位到问题模块",
  "checkOrder.noDataAvailable": "暂无数据",
  "checkOrder.initiatingCheck": "正在发起检查请稍后...",
  "checkOrder.failedInspection": "拆单完成，发起检查失败",
  "checkOrder.clickSeconds1": "",
  "checkOrder.clickSeconds2": "秒后可点击",
  "checkOrder.mandatory": "必选",
  "checkOrder.checkTheBox": "请勾选我已知悉",
  "checkOrder.checkTakes1": "当前检查用时",
  "checkOrder.checkTakes2": "秒...",
  "checkOrder.pleaseWait": "检查中，请稍后",
  "checkOrder.newInspection":
    " 检查结果已失效或订单内容发生变化，请重新发起检查",
  "checkOrder.confirmationForm": "物料生产基地确认表",
  "checkOrder.clickToFill": "点击填写",
  "checkOrder.submitted": "已提交",
  "checkOrder.unsubmitted": "未提交",
  "checkOrder.canOrder": "请发起检查并等待检查完成，结果无错误才可下单",
  "checkOrder.pleaseRecheck": "检查失败，请重新检查完成后再下单",
  "checkOrder.beforeSendingFlyer": "检查结果存在错误，请修改后再发起传单",
  "checkOrder.fillFormFirst": "表单未提交，请先填写表单",
  "checkOrder.riskAwareness": "检查结果有风险，请勾选风险悉知后再传单",
  "checkOrder.beforeExporting": "请发起检查并等待检查完成再导出结果",
  "checkOrder.selectChecked": "选择要检查的产品",
  "checkOrder.selectInspectionItem": "请选择检查项",
  "checkOrder.collapseResult": "收起结果",
  "checkOrder.viewResults": "查看结果",
  "checkOrder.initiateNewInspection": "请重新发起检查",
  "checkOrder.abnormalitiesCantOrder":
    "查有错误的产品不可下单，请点击【查看结果】并按说明修改错误后再下单",
  "checkOrder.confirmBeforePlacing ": "请勾选提示须知，确认后才可下单",
  "checkOrder.notCloseDesign1":
    "设计软件拆单中，请勿关闭当前下单的设计方案文件，请稍后，当前已用时",
  "checkOrder.notCloseDesign2": "秒...",
  "checkOrder.softwareCheck1": "设计软件正在进行工艺检查，请稍后，当前已用时",
  "checkOrder.softwareCheck2": "秒",
  "checkOrder.checkTime": "当前检查用时X秒...",
  "checkOrder.meetTheInspection":
    "所选产品不符合检查条件，请检查所选产品是否都已绑定和选择检查项",
  "checkOrder.haveBeenInformed":
    "我已知悉，检查结果存在错误时不可下单，存在风险时可下单但下单可能有退单风险”，需勾选后点击确定才能关闭当前提示页面",
  "checkOrder.customizedProducts": "定制品",
  "checkOrder.carefullyReview":
    "以上工艺问题，请认真查阅核对，出现质量等问题将作为售服依据，由设计自行承担。",
  "checkOrder.inspectionExport": "工艺检查结果不支持导出",
  "checkOrder.checkRisk": "请选勾选风险知悉",
  "checkOrder.followingSituations":
    "请检查以下情况后再下单：<p>1、若检查结果有错误，请修改错误后再下单；</p><p>2、若有风险，请阅读并勾选风险知悉后再下单；</p>",
  "checkOrder.inspectionProgress": "检查中，请稍等",
  "checkOrder.refreshInspection": "请刷新检查结果，若检查失败需重新检查",
  "checkOrder.unableCheck": "拆单未完成，未生成检查批次,无法检查",
  "checkOrder.refreshButton": "请点击刷新下单进度按钮",
  "checkOrder.obtainedBatchID": "暂未获取到检查批次ID，请重试",
  "checkOrder.inspectionIncomplete": "检查未完成/不通过,无法下单",
  "checkOrder.itemsApply": "以上检查项应用到所有",
  "checkOrder.channelProducts": "渠道产品",
  "checkOrder.cancel": "取消",
  "checkOrder.orderFirst": "请先选择服务单",
  "checkOrder.selectProductCategory": "请选择产品类别！",

  "checkOrder.orderCategory": "订单类别",
  "checkOrder.designer": "设计师",
  "checkOrder.designerPhone": "设计师电话",
  "checkOrder.draftsman": "绘图师",
  "checkOrder.draftsmanPhone": "绘图师电话",
  "checkOrder.expectedDeliveryTime": "期望交期",
  "checkOrder.createStandards": "创建单独标准品订单",
  "checkOrder.myOrderTask": "我的下单任务",
  "checkOrder.customerInfo": "客户信息",
  "checkOrder.serviceOrder": "服务单",
  "checkOrder.productsOrdered": "下单产品",
  "checkOrder.orderInfos": "下单信息",
  "checkOrder.orderInfo": "订单信息",
  "checkOrder.attachments": "附件",
  "checkOrder.detailsExpress": "详情说明",
  "checkOrder.sceneFiles": "场景文件",
  "checkOrder.spaceProductName": "空间产品名",
  "checkOrder.afterSalesOrder": "是否遗留单",
  "checkOrder.productChannels": "产品渠道",
  "checkOrder.standardProducts": "标准品",
  "checkOrder.placeAnOrder": "下单",
  "checkOrder.doNotPlaceAnOrder": "不下单",
  "checkOrder.design": "设计",
  "checkOrder.specs": "规格",

  "checkOrder.productType": "产品类型",

  "checkOrder.addStandardProducts": "添加标准品",
  "checkOrder.serviceOrderNumber": "服务单号",
  "checkOrder.noServiceOrderNumber": "无服务单号",
  "checkOrder.orderName": "合同自编号",
  "checkOrder.orderConsistent": "是否整单一致",
  "checkOrder.productCategory": "产品类别",
  "checkOrder.designSource": "设计来源",
  "checkOrder.approvalForm": "是否有线上审批",
  "checkOrder.assembled": "是否组装",
  "checkOrder.markType": "唛头类型",
  "checkOrder.assemblyMethod": "产品装配",
  "checkOrder.cartonRequirements": "纸箱要求",
  "checkOrder.logisticsMethods": "物流工艺",
  "checkOrder.displayRequirements": "摆样需求",
  "checkOrder.installationMethod": "水盆安装方式",
  "checkOrder.customerSupplied": "客供品配套",
  "checkOrder.projectInfo": "项目信息",
  "checkOrder.batchOrderQuantity": "批次下单数量",
  "checkOrder.remarks": "备注",
  "checkOrder.variableTable": "变量表",
  "checkOrder.view": "查看",
  "checkOrder.setup": "设置",
  "checkOrder.orderQuantity": "下单数量",
  "checkOrder.orderableQuantity": "可下单数量",
  "checkOrder.ordersPlacedNunmber": "本次下单数量",
  "checkOrder.upload": "上传",
  "checkOrder.splittingOrders": "拆单说明",
  "checkOrder.splitOrderSuccessful": "拆单成功",
  "checkOrder.splitOrderFailed": "拆单失败",
  "checkOrder.initiateInspection": "发起检查",
  "checkOrder.oneClickOrder": "一键下单",
  "checkOrder.refreshOrder": "刷新下单进度",
  "checkOrder.relatedOrderApplication": "关联下单申请",
  "checkOrder.buildingAbbreviation": "楼盘简称",
  "checkOrder.orderApplicationNo": "下单申请编号",
  "checkOrder.numberOfSetsOrdered": "下单套数",
  "checkOrder.search": "搜索",
  "checkOrder.addServiceOrder": "新增服务单",
  "checkOrder.option": "选项",
  "checkOrder.houseType": "户型",
  "checkOrder.schemeNo": "方案号",
  "checkOrder.orderQuantitys": "订单数",
  "checkOrder.engineerServiceOrder": "工程服务单",
  "checkOrder.batchSettings": "批量设置",
  "checkOrder.brandCategory": "所属品牌品类",
  "checkOrder.orderType": "订单类型",
  "checkOrder.EngineeringServiceNumber": "工程服务单号",
  "checkOrder.splitOrderDetails": "拆单详情",
  "checkOrder.initiateSplitOrder": "发起拆单",
  "checkOrder.option": "选项",
  "checkOrder.serialNumber": "序号",
  "checkOrder.placeOrderOrNot": "是否下单",
  "checkOrder.customerName": "客户姓名",
  "checkOrder.customerPhone": "客户电话",
  "checkOrder.customerAddress": "客户地址",
  "checkOrder.associateBefore": "请先关联下单申请再下单",
  "checkOrder.selectSceneFirst": "请先选择方案场景文件",
  "checkOrder.faucetCode": "水龙头编码",
  "checkOrder.deliveryTomorrow": "期望交期需选择明天以后",
  "checkOrder.basinInstallation": "水盆安装方式不能为空",
  "checkOrder.assembleEmpty": "是否组装不能为空",
  "checkOrder.quantityEmpty": "批次下单数量不能为空",
  "checkOrder.nonStandardApproval": "请选择非标审批单据",
  "checkOrder.serviceOrderIdEmpty": "服务单id不能为空，请选择其它服务单",
  "checkOrder.quantityOrderEmpty": "本次下单数量不能为0",
  "checkOrder.brandCategoryConsistent":
    "组合柜的品牌品类须和服务单品牌品类一致",
  "checkOrder.contractNumberInvalid": "所选服务单合同号无效,请更换服务单",
  "checkOrder.requiresSettingVariables": "非整单一致需要设置变量",
  "checkOrder.sourceEmpty": "设计来源不能为空",
  "checkOrder.variableEmpty":
    "未设置变量，需关联整单一致的服务单，请检查变量或服务单是否正确",
  "checkOrder.variableNotEmpty":
    "已设置变量，需关联非整单一致的服务单，请检查变量或服务单是否正确",
  "checkOrder.categoryEmpty": "产品类别不能为空",
  "checkOrder.expectedDeliveryEmpty": "期望交期不能为空",
  "checkOrder.spaceProductsEmpty": "空间产品不能为空",
  "checkOrder.associatedOrderEmpty": "关联工程服务单不能为空",
  "checkOrder.markTypeEmpty": "唛头类型不能为空",
  "checkOrder.assemblyEmpty": "产品装配不能为空",
  "checkOrder.cartonEmpty": "纸箱要求不能为空",
  "checkOrder.LogisticsProcessEmpty": "物流工艺不能为空",
  "checkOrder.sampleDisplayEmpty": "摆样需求不能为空",
  "checkOrder.customerSuppliesEmpty": "客供品配套不能为空",
  "checkOrder.selectedItemN":
    "本次下单数量不能为0，请先在变量设置中设置是否下单",
  "checkOrder.pleaseCheck": "请勾选订单明细",
  "checkOrder.orderIsRepeated":
    "关联的工程服务单出现重复，请修改关联不同的工程服务单进行下单！",
  "checkOrder.contractSelfNumber":
    "关联的工程服务单出现重复的合同自编号，请重新修改再下单",
  "checkOrder.sceneContentChanged": "场景内容发生改变，请确认下单信息",
  "checkOrder.retailOrdersSinks": "零售订单水槽不可下单盆，请选择套盆下单",
  "checkOrder.attachmentsModified": "下单后不能修改附件",
  "checkOrder.splitOrderNotCompleted": "拆单未完成，无法继续下单",
  "checkOrder.newInspection": "请重新发起检查拆单!",
  "checkOrder.caxaCounterTop": "请填写不使用CAXA台面图原因",
  "checkOrder.illegalCharacters1": "上传附件文件名包含非法字符",
  "checkOrder.illegalCharacters2": "请修正文件名重传",
  "checkOrder.notAllowXml": "一键下单不允许用户自行上传xml文件",
  "checkOrder.notAllowCountertop":
    "当前上传的文件命名中含有“台面”字样，如需上传台面文件请选择“台面附件”类型上传（卫浴台面图通过CAXA生成，不允许自行上传）。",
  "checkOrder.notCloseDesignFile":
    "设计软件拆单中，请勿关闭当前下单的设计方案文件，请稍后，当前已用时",
  "checkOrder.individualStandard": "单独标准品订单无需拆单，可直接下单",
  "checkOrder.successfullySubmitted":
    "提交拆单成功，可停留当前页面刷新拆单进度，也可关闭当前页面到下单任务中查看进度",
  "checkOrder.taskAlreadyHas":
    "当前下单任务已有拆单任务，本次操作将生成新的下单任务，请确认是否继续",
  "checkOrder.orderNotDetected":
    "工程服务单未检测到相关合同自编号,请重新选择有效工程服务单",
  "checkOrder.sceneNotVariables": "场景文件未设置变量，或数据返回异常请检查！",
  "checkOrder.serviceOrderAgain1":
    "该服务单未查询出遗留单合同号,无法下单,请重新选择服务单",
  "checkOrder.serviceOrderAgain2":
    "该服务单未查询出合同号,无法下单,请重新选择服务单",
  "checkOrder.canBePlaced":
    '服务单只有"未建单"、"建单成功"、"建单失败","设计文件处理中"、"设计文件处理成功"、"设计文件处理失败"状态下才可下单',
  "checkOrder.readingScene": "正在读取方案内容",
  "checkOrder.batchDownload": "批量下载拆单文件",
  "checkOrder.hasBeenSubmitted":
    "一键下单已提交，具体下单结果请到【我的下单任务】查看",
  "checkOrder.selectedItem": "所选项第",
  "checkOrder.and": "和",
  "checkOrder.name": "姓名",
  "checkOrder.accountNumber": "账号",
  "checkOrder.orderApplications": "请选择下单申请",
  "checkOrder.applicationInvalid": "所选下单申请无效/无服务单号",
  "checkOrder.applicationRelated": "关联工程下单申请完成",
  "checkOrder.non-standardMaterials":
    "有非标物料的审批时，产品类别请选择非标物料",
  "checkOrder.countertopAttachment":
    "注意：如需要上传台面相关附件，请选择“台面附件”类型上传",
  "checkOrder.notAllowedCad":
    "7月10日起，橱柜工程台面不允许CAD下单，如有疑问请从答疑平台咨询",
  "checkOrder.enterContractNumber": "请输入合同自编号",
  "checkOrder.variableSettings": "变量设置",
  "checkOrder.importVariable": "导入变量表",
  "checkOrder.exportVariable": "导出变量表",
  "checkOrder.orderOrNot": "是否下单",
  "checkOrder.clearVariable": "清空当前变量值",
  "checkOrder.reuseVariable": "复用历史变量值",
  "checkOrder.viewingVariable": "查看历史变量值",
  "checkOrder.resetVariable": "请重新设置变量",
  "checkOrder.displayOrderInformation": "关联下单申请后显示订单信息",
  "checkOrder.pleaseSelect": "请选择",
  "checkOrder.personnelList": "人员列表",
  "checkOrder.nameJobMobile": "姓名/工号/手机号",
  "checkOrder.option": "选项",
  "checkOrder.departmentStore": "部门/门店",
  "checkOrder.post": "岗位",
  "checkOrder.resignationOrNot": "是否离职",
  "checkOrder.total": "共",
  "checkOrder.page": "页",
  "checkOrder.goTo": "前往",

  "checkOrder.searchContract": "搜索合同自编号、订单编号",
  "checkOrder.batchOrderPlacement": "批量传单",
  "checkOrder.numberOfSets": "套数",
  "checkOrder.projectBatchInformation": "项目批次信息",
  "checkOrder.factoryPlanned": "工厂计划交期",
  "checkOrder.administrativeDivision": "行政区划",
  "checkOrder.placeOrderNot": "是否传单",
  "checkOrder.FlyerTime": "传单时间",
  "checkOrder.specificAddress": "具体地址",
  "checkOrder.otherAttachments": "其他附件",
  "checkOrder.counterTopAttachments": "台面附件",
  "checkOrder.priceAttachments": "价格附件",
  "checkOrder.uploadAttachments": "上传附件",
  "checkOrder.counterTop": "台面",
  "checkOrder.selectAll": "全选",
  "checkOrder.startDate": "开始日期",
  "checkOrder.endDate": "结束日期",
  "checkOrder.to": "至",
  "checkOrder.selectBrand": "请选择品牌",
  "checkOrder.selectCategory": "请选择品类",
  "checkOrder.transferred": "转派给",
  "checkOrder.clickTransferred": "点击转派给",
  "checkOrder.oderUpdateTime": "订单更新时间",
  "checkOrder.noDataAvailable": "暂无数据",
  "checkOrder.loadingDesperately": "拼命加载中",
  "checkOrder.orderUpdateTime":
    "请根据订单更新时间确认所勾选的订单为最新下单信息",
  "checkOrder.successfullyPlaced": "传单成功",
  "checkOrder.defaultOrderType": "PTD-WMD-10-30-外贸单-普通单",
  "checkOrder.enter": "请输入",
  "checkOrder.designerPhoneEmpty": "设计师电话不能为空",
  "checkOrder.designerEmpty": "设计师不能为空",
  "checkOrder.selectDate": "选择日期",
  "checkOrder.modifyingSpace":
    "修改空间产品名后无法覆盖已有订单，请确认订单是否已经上传，避免造成订单重复",
  "checkOrder.coverTabletop":
    "本次上传的台面图将覆盖设计软件拆单附件中的台面图，请确认是否替换？",

  "checkOrder.oppein": "欧派",
  "checkOrder.oboli": "欧铂丽",
  "checkOrder.oboni": "欧铂尼",
  "checkOrder.owell": "奥维",
  "checkOrder.baunis": "铂尼思",
  "checkOrder.starhomes": "STARHOMES",
  "checkOrder.oboladi": "欧铂拉迪",
  "checkOrder.fitzcarl": "菲恩卡尔",
  "checkOrder.baunisStarhomes": "铂尼恩Baunis",
  "checkOrder.miform": "miform",
  "checkOrder.outu": "欧图",

  "checkOrder.youcai": "优材",
  "checkOrder.zhuangxiu": "装修",
  "checkOrder.zhucaijicheng": "主材集成",
  "checkOrder.zhuangjiamen": "装甲门",
  "checkOrder.bancai": "板材",
  "checkOrder.shangchu": "商橱",
  "checkOrder.jinshumenchuang": "金属门窗",
  "checkOrder.dajiaju": "大家居",
  "checkOrder.qiangshi": "软装",
  "checkOrder.mumen": "木门",
  "checkOrder.zhinengjiaju": "智能家居与照明",
  "checkOrder.weiyu": "卫浴",

  "checkOrder.wardrobe": "集成家居",
  "checkOrder.cabinet": "橱柜",
  "checkOrder.queuing": "排队中",
  "checkOrder.splittingOrders": "拆单中",
  "checkOrder.successfullySplit": "拆单成功",
  "checkOrder.splitOrderFailed": "拆单失败",
  "checkOrder.cancelSplit": "取消拆单",
  "checkOrder.simpleOrder": "简易拆单",
  "checkOrder.fullOrder": "全量拆单",
  "checkOrder.taskStatus": "请选择任务状态",
  "checkOrder.taskType": "请选择任务类型",
  "checkOrder.splitRecord": "请选择需要导出的拆单记录!",
  "checkOrder.splitNoFiles": "没有拆单成功的文件，请确认!",
  "checkOrder.cancelSplitSuccess": "取消拆单成功",
  "checkOrder.selectPersonnel": "请选择人员",
  "checkOrder.notCreated": "未建单",
  "checkOrder.creating": "建单中",
  "checkOrder.createdSuccessfully": "建单成功",
  "checkOrder.creationFailed": "建单失败",
  "checkOrder.designFileProcessing": "设计文件处理中",
  "checkOrder.successfullyDesignFiles": "设计文件处理成功",
  "checkOrder.designFileFailed": "设计文件处理失败",
  "checkOrder.draftSaved": "已保存草稿",
  "checkOrder.readingScheme": "正在读取方案内容",
  "checkOrder.uploadSuccessful": "上传成功",
  "checkOrder.batchSetBrand": "已批量设置相同品牌品类的产品类别",
  "checkOrder.enoppein": "OPPEIN",
  "checkOrder.importCompleted": "导入完成",
  "checkOrder.exporting": "正在导出,请稍等...",
  "checkOrder.deleteTask": "确定删除该下单任务?删除后任务记录不可见",
  "checkOrder.successfullyDeleted": "删除成功",
  "checkOrder.confirmation": "下单成功",
  "checkOrder.useCaxaTabletop": "请选择不使用CAXA台面图原因",
  "checkOrder.successfullyDeleted": "删除成功",
  "checkOrder.deleteOrder": "你确定要删除订单吗？",
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/check/settings.js